var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.43518C6.477 2.43518 2 6.91218 2 12.4352C2 17.9582 6.477 22.4352 12 22.4352C17.523 22.4352 22 17.9582 22 12.4352C22 6.91218 17.523 2.43518 12 2.43518ZM12.0081 7.43518C13.6651 7.43518 15.0081 8.77818 15.0081 10.4352C15.0081 12.0922 13.6651 13.4352 12.0081 13.4352C10.3511 13.4352 9.00806 12.0922 9.00806 10.4352C9.00806 8.77818 10.3511 7.43518 12.0081 7.43518ZM12 20.9352C9.79 20.9352 7.77001 20.0852 6.26001 18.6952C6.70001 17.3152 7.84004 16.0051 10.29 16.0051H13.71C16.15 16.0051 17.29 17.3252 17.74 18.6952C16.23 20.0852 14.21 20.9352 12 20.9352Z",
    fill: "#707496"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.838b46794b0d4d70f50daf43536ddc1f.svg";
export { ForwardRef as ReactComponent };